import { call, put, select, takeLatest } from 'redux-saga/effects';

import * as deviceListApi from 'src/service/api/deviceList';
import * as deviceListActions from './action';
import { getDeviceListState } from './selector';

export function * deviceListRoot () {
  yield takeLatest([deviceListActions.FETCH_DEVICE_LIST, deviceListActions.FETCH_DEVICE_LIST_NEXT_PAGE], fetchPage);
}

function * fetchPage (action) {
  const state = yield select(getDeviceListState);

  try {
    const page = yield call(deviceListApi.getDeviceList, action, state.get('query'), state.get('nextOffset'));
    yield put(deviceListActions.fetchDeviceListSuccess(page));
  } catch (err) {
    yield put(deviceListActions.fetchDeviceListFailed(err));
  }
}
